// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.step-table-info-banner[data-v-2e73a53a] {\n  position: relative;\n  top: 50px;\n  left: 50%;\n  -webkit-transform: translate(-50%);\n          transform: translate(-50%);\n  width: 80%;\n  z-index: 1000;\n}\n", ""]);
// Exports
module.exports = exports;
